export { default } from './InnerForm';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Form/InnerForm/index.js